<template>
  <div class="bids-add-bulk-column-chooser-column">
    <header class="bids-add-bulk-column-chooser-column__header">
      <h3 class="bids-add-bulk-column-chooser-column__title">
        {{
          $t('ADVERTISEMENT.BULK_IMPORT.COLUMN_CHOOSER_COLUMN_TITLE', {
            name: title,
          })
        }}
      </h3>
    </header>
    <ul class="bids-add-bulk-column-chooser-column__list">
      <li
        v-for="(item, index) in items"
        :key="item + index"
        class="bids-add-bulk-column-chooser-column__list-item"
      >
        {{ item }}
      </li>
    </ul>
    <div class="bids-add-bulk-column-chooser-column__action-wrapper">
      <button
        class="bids-add-bulk-column-chooser-column__action"
        :class="{
          'bids-add-bulk-column-chooser-column__action--chosen': isSelected,
        }"
        @click="emitSelected"
      >
        <template v-if="isSelected">
          <i
            class="el-icon-check bids-add-bulk-column-chooser-column__action-icon"
          />
          {{ $t('ADVERTISEMENT.BULK_IMPORT.COLUMN_CHOOSER_SELECTED_COLUMN') }}
        </template>
        <template v-else>
          {{ $t('ADVERTISEMENT.BULK_IMPORT.COLUMN_CHOOSER_SELECT_COLUMN') }}
        </template>
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'BidsAddBulkColumnChooserColumn',
  props: {
    title: {
      required: true,
      type: [String, Number],
    },
    items: {
      required: true,
      type: Array,
    },
    isSelected: {
      default: false,
      type: Boolean,
    },
  },
  methods: {
    emitSelected() {
      if (this.isSelected) this.$emit('deSelected');
      else this.$emit('selected');
    },
  },
};
</script>

<style lang="scss">
.bids-add-bulk-column-chooser-column {
  border: 1px solid $lb-lighter-gray;
  border-radius: $lb-border-radius * 2;
  padding-bottom: $global-padding / 2;

  &__header {
    background-color: $lb-lighter-gray;
  }

  &__title {
    font-size: $lb-smaller-font-size;
    padding: $global-padding;
    margin: 0;
  }

  &__list {
    margin: 0;
    list-style-type: none;

    &-item {
      padding: $global-padding / 2 $global-padding;
      border-bottom: 1px solid $lb-lighter-gray;
    }
  }

  &__action-wrapper {
    padding: 0 $global-padding / 2;
    margin-top: $global-margin;
  }

  &__action {
    padding-top: $global-padding / 2;
    padding-bottom: $global-padding / 2;

    text-align: center;

    border-radius: $lb-border-radius * 2;
    border: 2px solid $lb-black;

    width: 100%;
    cursor: pointer;

    display: flex;
    align-items: center;
    justify-content: center;

    &-icon {
      margin-left: calc($global-margin / 2);
    }

    &--chosen {
      border-color: $lb-color-primary;
      color: $lb-color-primary;
    }

    &:focus {
      outline: none;
    }
  }
}
</style>
